// src/Views/ContentUnavailableView.js
import React from 'react';
import { Link } from 'react-router-dom';
import { MAX_CONTENT_WIDTH, BORDER_RADIUS, SPACING_BUTTON, SPACING_CARD, SPACING_CARD_BODY, SPACING_GROUP, SPACING_COMPONENT } from '../constants/layout';
import { FONT_TITLE2 } from '../constants/typography';

function ContentUnavailableView({ icon, title, description, actions, children }) {
  return (
    <div className="content-unavailable-container">
      <div className="content-unavailable">
        <div className="content-unavailable-icon">
          <span className="material-icons">{icon}</span>
        </div>
        <h2 className="content-unavailable-title">{title}</h2>
        <p className="content-unavailable-description">{description}</p>

        {actions && actions.length > 0 && (
          <div className="content-unavailable-actions">
            {actions.map((action, index) =>
              action.to ? (
                <Link
                  key={index}
                  to={action.to}
                  className={`content-unavailable-action ${action.style === 'secondary' ? 'action-secondary' : 'action-primary'}`}
                >
                  {action.label}
                </Link>
              ) : (
                <button
                  key={index}
                  onClick={action.onClick}
                  className={`content-unavailable-action ${action.style === 'secondary' ? 'action-secondary' : 'action-primary'}`}
                >
                  {action.label}
                </button>
              )
            )}
          </div>
        )}

        {children}
      </div>

      <style jsx>{`
        .content-unavailable-container {
          max-width: ${MAX_CONTENT_WIDTH};
          margin: 0 auto;
          padding: 0 ${SPACING_BUTTON};
          min-height: calc(100vh - 200px);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .content-unavailable {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: ${SPACING_CARD_BODY};
          text-align: center;
        }

        .content-unavailable-icon {
          margin-bottom: ${SPACING_CARD_BODY};
          opacity: 0.5;
        }

        .content-unavailable-icon .material-icons {
          font-size: 80px;
          color: var(--color-text-secondary);
        }

        .content-unavailable-title {
          font-size: ${FONT_TITLE2};
          font-weight: 600;
          margin: 0 0 6px 0;
          color: var(--color-text-primary);
        }

        .content-unavailable-description {
          font-size: 1rem;
          color: var(--color-text-secondary);
          margin: 0 0 ${SPACING_GROUP} 0;
          line-height: 1.5;
        }

        .content-unavailable-actions {
          display: flex;
          flex-direction: column;
          gap: ${SPACING_COMPONENT};
        }

        .content-unavailable-action {
          display: inline-block;
          padding: ${SPACING_COMPONENT} ${SPACING_CARD_BODY};
          border-radius: ${BORDER_RADIUS};
          font-family: inherit;
          font-size: 1rem;
          font-weight: 600;
          line-height: 1.5;
          text-decoration: none;
          text-align: center;
          box-sizing: border-box;
          cursor: pointer;
          transition: background-color 0.2s ease;
        }

        .action-primary {
          background-color: var(--color-accent);
          color: var(--color-accent-text);
          border: none;
        }

        .action-primary:hover {
          background-color: var(--color-accent-hover);
        }

        .action-secondary {
          background-color: transparent;
          color: var(--color-accent);
          border: 1px solid var(--color-accent);
        }

        .action-secondary:hover {
          background-color: var(--color-accent);
          color: var(--color-accent-text);
        }
      `}</style>
    </div>
  );
}

export default ContentUnavailableView;
